<template>
  <div
    class="d-flex show-event"
    :class="{ 'small-variant': small || $vuetify.breakpoint.smAndDown }"
  >
    <div
      v-if="showLogo"
      class="reserverd-logo-space d-print-none"
      style="align-self: center"
    >
      <AppOrganLogo :organiser="event.organiser" :image-style="imageStyle" />
    </div>
    <div :class="{ 'reserverd-event-details': showLogo, 'pl-3': showLogo }">
      <div class="show-event--date-location">
        <template v-if="!ignoreDate">
          {{ eventDate }}
          <span class="line"
        /></template>
        <AppShowCountry :country="event.country" /> {{ RegionName }},
        {{ event.place }}
        <span>
          <AppShowEventStatus
            v-if="showStatus"
            :event="event"
            border
            no-button
            always-show
          />
        </span>
      </div>
      <div class="show-event--title">
        <AppShowEventName
          :event="event"
          :disable-link="!link"
          :target-link="targetLink"
        />
        <v-icon v-if="event.isHighlighted" class="star-icon" color="star">
          $iconStar
        </v-icon>
      </div>
      <div class="show-event--organiser">
        <slot name="organiser">
          {{ event.organiser.name }}
          <template v-if="event.hostOrganisation">
            | {{ event.hostOrganisation.name }}</template
          ></slot
        >
      </div>
    </div>
  </div>
</template>
<script>
import gql from "fraql";
import AppOrganLogo from "@elements/AppOrganLogo.vue";
import AppShowCountry from "@AppShows/AppShowCountry.vue";
import AppShowEventStatus from "@AppShows/event/AppShowEventStatus.vue";
import AppShowEventName from "./AppShowEventName.vue";

export default {
  name: "AppShowEventDetails",
  components: {
    AppShowEventStatus,
    AppShowCountry,
    AppOrganLogo,
    AppShowEventName
  },
  props: {
    event: {
      type: Object,
      required: true
    },
    link: {
      type: Boolean,
      default: false
    },
    targetLink: {
      type: String,
      default: undefined
    },
    small: {
      type: Boolean,
      default: false
    },
    showStatus: {
      type: Boolean,
      default: false
    },
    showLogo: {
      type: Boolean,
      default: false
    },
    ignoreDate: {
      type: Boolean,
      default: false
    }
  },
  fragments: {
    event: gql`
      fragment _ on Event {
        id
        name
        startDate
        endDate
        ${AppShowEventName.fragments.event}
        ${AppShowEventStatus.fragments.eventStatus}
        place
        regionId
        region @client {
          id
          name
        }
        disciplineId
        discipline @client {
          id
          name
        }
        countryId
        country @client {
         ${AppShowCountry.fragments.country}
        }
        
        isHighlighted
        registrationEndDate
        organiser {
          id
          name
          logoPath
          ${AppOrganLogo.fragments.organiser}
        }
        hostOrganisation {
          id
          name
        }
      }
    `
  },
  computed: {
    discipline() {
      return this.event.discipline;
    },
    imageStyle() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "max-height: 64px;max-width: 100%;";
      } else {
        return "max-height: 48px;max-width: 100%;";
      }
    },
    eventDate() {
      return this.$dayjs.nicerDate(this.event.startDate, this.event.endDate);
    },
    RegistrationDeadline() {
      if (this.event.registrationEndDate)
        return this.$dayjs.date(this.event.registrationEndDate);
      else return "???";
    },
    RegionName() {
      if (this.event.region) return this.event.region.name;
      else return "";
    }
  }
};
</script>
<style lang="scss">
.reserverd-logo-space {
  width: 15%;
}
.reserverd-event-details {
  width: 85%;
}
.show-event {
  &--date-location {
    font-size: 18px;
    .line {
      margin: 0 6px;
      border: 1px solid #9b9b9b;
      background: #9b9b9b;
      width: 1px;
    }
  }

  &--title {
    font-size: 21px;
    /*margin-top: 30px;*/
  }
  .star-icon {
    font-size: 24px;
  }
  &--organiser {
    text-transform: uppercase;
  }

  &.small-variant {
    .show-event--organiser,
    .show-event--date-location {
      font-size: 12px;
    }
    .star-icon {
      font-size: 16px;
    }
    .show-event--title {
      font-size: 16px;
    }
  }
}
</style>
